import { render, staticRenderFns } from "./HeaderPartnership3.vue?vue&type=template&id=6a0a9242"
import script from "./HeaderPartnership3.vue?vue&type=script&lang=ts"
export * from "./HeaderPartnership3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports